<template>
  <div id="footer">
    <div class="container">
      <el-row class="footer_txt">
        <el-col :span="12" class="serve">
          <ul>
            <li>
              <a href="#">关于远达</a>
            </li>
            <li>
              <router-link tag="a" to="/about/brief" href="#">关于远达</router-link>
            </li>
            <li>
              <router-link tag="a" to="/about/events" href="#">关于大事记</router-link>
            </li>
            <li>
              <router-link tag="a" to="/about/honour" href="#">荣誉与认证</router-link>
            </li>
            <li>
              <router-link tag="a" to="/about/contact" href="#">联系我们</router-link>
            </li>
          </ul>
          <ul>
            <li>
              <a href="#">法律条款</a>
            </li>
            <li>
              <a href="#">隐私声明</a>
            </li>
          </ul>
          <ul>
            <li>
              <a href="#">帮助中心</a>
            </li>
            <li>
              <a href="#">常见问题</a>
            </li>
            <li>
              <a href="#">意见反馈</a>
            </li>
          </ul>
        </el-col>
        <el-col :span="7" class="contact">
          <ul>
            <li>联系方式</li>
            <li>联系电话：029-88823955</li>
            <li>联系邮箱：yd@yuandacloud.com</li>
            <li>公司网址：http://www.yuandacloud.com</li>
            <li>
              公司地址：陕西省西安市高新区科技二路72号
              西安软件园天泽大厦二楼
            </li>
          </ul>
        </el-col>
        <el-col :span="4" class="wechat">
          <p>微信公众号</p>
          <div class="wetchat_img">
            <img src="../assets/images/wechat.png" alt="wechat" />
          </div>
        </el-col>
      </el-row>
      <a
        href="http://icp.chinaz.com/home/info?host=worldwideweb.org.cn"
        target="_blank"
      >Copyright ©2015-2020 陕西远达智能科技有限公司 陕ICP备19005284号</a>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="less" scoped>
#footer {
  width: 100%;
  height: 367px;
  background: url("../assets/images/footer_background.png") no-repeat;
  background-position: center;
  .container {
    width: 1200px;
    margin: 0 auto;
    padding-top: 59px;
    p {
      font-size: 14px;
      line-height: 20px;
      color: rgba(51, 51, 51, 1);
      opacity: 0.61;
    }
    .footer_txt {
      border-bottom: 1px solid rgba(241, 241, 241, 1);
      padding-bottom: 20px;
      margin-bottom: 20px;
    }
    .serve {
      display: flex;
      font-size: 16px;
      li:nth-child(1) {
        margin-bottom: 31px;
      }
      li:nth-child(n + 2) {
        font-size: 14px;
        margin-bottom: 16px;
      }
      ul {
        margin-right: 80px;
      }
    }
    .contact {
      font-size: 16px;
      ul li:nth-child(1) {
        margin-bottom: 31px;
      }
      ul li:nth-child(n + 2) {
        font-size: 14px;
        margin-bottom: 16px;
      }
    }
    .wechat {
      padding-left: 80px;
    }
    .wechat p {
      margin-bottom: 30px;
      font-size: 16px;
    }
  }
}
</style>